// Helper to generate random numbers within a range
const getRandomNumber = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

// Helper to generate random dates within a range
const getRandomDate = (start, end) => {
  return new Date(
    start.getTime() + Math.random() * (end.getTime() - start.getTime())
  );
};

// Helper to format date as YYYY-MM-DD
const formatDate = (date) => {
  return date.toISOString().split("T")[0];
};

// Sample product categories
const productCategories = [
  "Burgers",
  "Pizzas",
  "Salads",
  "Desserts",
  "Drinks",
  "Sides",
  "Combos",
];

// Sample complement categories
const complementCategories = [
  "Toppings",
  "Sauces",
  "Extras",
  "Sides",
  "Beverages",
];

// Sample restaurant names
const restaurantNames = [
  "Burger Palace",
  "Pizza Heaven",
  "Salad Garden",
  "Sweet Delights",
  "Beverage Corner",
];

// Generate fake product sales data
export const getFakeProductData = () => {
  // Generate top selling products
  const topSellingProducts = Array.from({ length: 10 }, (_, i) => ({
    id: `prod-${i + 1}`,
    title: `Product ${i + 1}`,
    totalQuantity: getRandomNumber(100, 1000),
    totalRevenue: getRandomNumber(1000, 10000) / 100,
    avgOrderValue: getRandomNumber(1000, 5000) / 100,
    category:
      productCategories[getRandomNumber(0, productCategories.length - 1)],
  })).sort((a, b) => b.totalQuantity - a.totalQuantity);

  // Generate product sales trend data (last 30 days)
  const endDate = new Date();
  const startDate = new Date();
  startDate.setDate(startDate.getDate() - 30);

  const productSalesTrend = Array.from({ length: 30 }, (_, i) => {
    const date = new Date(startDate);
    date.setDate(date.getDate() + i);

    return {
      date: formatDate(date),
      totalSales: getRandomNumber(5000, 15000) / 100,
      totalQuantity: getRandomNumber(50, 200),
      topProduct: topSellingProducts[getRandomNumber(0, 4)].title,
    };
  });

  // Generate product category distribution
  const productCategoryDistribution = productCategories.map((category) => ({
    name: category,
    value: getRandomNumber(100, 1000),
    revenue: getRandomNumber(10000, 50000) / 100,
  }));

  // Generate complement popularity data
  const complementPopularity = Array.from({ length: 8 }, (_, i) => ({
    id: `comp-${i + 1}`,
    title: `Complement ${i + 1}`,
    category:
      complementCategories[getRandomNumber(0, complementCategories.length - 1)],
    totalQuantity: getRandomNumber(50, 500),
    totalRevenue: getRandomNumber(500, 5000) / 100,
    attachRate: getRandomNumber(10, 50) / 100, // Percentage of orders with this complement
  })).sort((a, b) => b.totalQuantity - a.totalQuantity);

  // Generate restaurant product performance
  const restaurantProductPerformance = restaurantNames
    .map((name) => ({
      name,
      productCount: getRandomNumber(20, 100),
      topSellingProduct: topSellingProducts[getRandomNumber(0, 9)].title,
      totalRevenue: getRandomNumber(50000, 200000) / 100,
      avgOrderValue: getRandomNumber(3000, 8000) / 100,
    }))
    .sort((a, b) => b.totalRevenue - a.totalRevenue);

  return {
    topSellingProducts,
    productSalesTrend,
    productCategoryDistribution,
    complementPopularity,
    restaurantProductPerformance,
  };
};
